import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthDataService } from '../services/data-access/auth-data.service';

/**
 * Guard factory to restrict route access based on allowed user roles.
 * Supports: 'applicant', 'approver', 'tenantadmin', etc.
 */
export function roleGuard(allowedRoles: string[]): CanActivateFn {
  return () => {
    const authData = inject(AuthDataService);
    const router = inject(Router);

    if (!authData.isAuthenticated()) {
      return router.createUrlTree(['/auth/login']);
    }

    const currentRole = authData.getUserRole().toLowerCase().replace(/[-_\s]/g, '');
    
    const normalizedAllowed = allowedRoles.map((r) => r.toLowerCase().replace(/[-_\s]/g, ''));

    // Check if the user's role matches any allowed role (support synonyms like admin/tenantadmin)
    const hasRole = normalizedAllowed.some((allowed) => {
      if (allowed.includes('admin') || allowed.includes('tenantadmin')) {
        return currentRole.includes('admin') || currentRole.includes('tenantadmin');
      }
      if (allowed.includes('approv')) {
        return currentRole.includes('approv');
      }
      if (allowed.includes('applicant') || allowed.includes('user')) {
        return currentRole.includes('applicant') || currentRole.includes('user') || !currentRole;
      }
      return currentRole === allowed;
    });

    if (hasRole) {
      return true;
    }

    // Redirect to user's authorized home route
    const targetHome = authData.getRoleHomeRoute();
    return router.createUrlTree([targetHome]);
  };
}
